import { render, staticRenderFns } from "./index.vue?vue&type=template&id=542f2b52&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=542f2b52&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "542f2b52",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('542f2b52')) {
      api.createRecord('542f2b52', component.options)
    } else {
      api.reload('542f2b52', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=542f2b52&scoped=true", function () {
      api.rerender('542f2b52', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form/index.vue"
export default component.exports